import type { Locale } from 'date-fns';

import { DATE_FNS_LOCALES } from './constants';
import { usePreferredLocale } from './usePreferredLocale';

export function useDateFnsLocale(): Locale {
  const { locale } = usePreferredLocale();
  return DATE_FNS_LOCALES[locale];
}
